import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=5b3917d6&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3917d6",
  null
  
)

export default component.exports